
/// <summary>
// This widget displays edit log entries for a single analog signal in a
// split-view layout:
//   - LEFT: Scrollable list of edit log entries for a selected day.
//   - RIGHT: Detail panel with chart visualizations (archive/raw) and
//     a change log showing individual value modifications (from -> to).
//
// Communication with the server-side C# "List" visual class is done via
// AJAX through the inherited getData() method from vcBaseV4.
/// <br/>
/// Author: AFU<br />
/// Date: 20.1.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 4.6.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.EditLogList", jQuery.common.vcBaseV4, {

    // Stores fetched server data (the list of edit log entries for the current day).
    myData: {
        list: null,
    },

    // Tracks current UI state: currently selected entry and pre-calculated chart dimensions.
    myStatus: {
        entry: "",
        charts: { heightFull: 0, heightSplit: 0 }
    },

    /**
     * Widget constructor. Registers this visual with type ID 405
     * and invokes the parent class constructor.
     */
    _create: function () {
        this._createVisual(405);
        this._super();
    },

    /**
     * Initializes the widget's HTML structure.
     * Called by the base class during the widget creation lifecycle.
     * Sets the root element, reads the initial day from server parameters,
     * builds the DOM, and calculates responsive layout dimensions.
     *
     * @returns {boolean} true on success, false on error.
     */
    _initHTML: function () {
        var me = this;
        try {
            // Locate the root container element by its CSS class.
            me._setRoot(".dc-editlog-list");

            // Read the default day from the server-side visual parameter
            // (embedded as JSON in the data-visualdata attribute).
            me.myStatus.day = me.options.parameter.Day;

            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

            // Calculate and apply element dimensions relative to the visual's total size.
            me._setHeightsAndWidths();
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    /**
     * Initializes event handlers and performs the initial data load.
     * Called by the base class after _initHTML completes.
     *
     * @returns {boolean} true on success, false on error.
     */
    _initEvents: function () {
        var me = this;
        try {

            // Bind all interactive event handlers (buttons, list clicks, date picker).
            me._initStructure();

            // Trigger the first server fetch for the initial day.
            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    /**
     * Builds the complete HTML DOM structure for the widget.
     * Layout overview:
     * @returns {boolean} true on success, false on error.
     */
    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            // Master reference object holding all DOM element references for easy access.
            me.myHtml = {
                menu: {}, content: { details: {}, list: {} }
            };

            //me.myRoot.css("border", "1px solid red");

            // ----- TOP MENU BAR -----
            // Contains the reload button and the date selector.
            let obj = me.myHtml.menu;
            obj.wrapper = me._setObj("", "vc-grid-margin-bottom").css("width", "100%").css("height", "80px");
            obj.reload = me._setMainButton("reload", me.specific.resources.iconReload, me.specific.resources.reload).addClass("active");
            obj.date = me._setObj("date", "optionbox vc-grid-2col float-box");
            obj.wrapper.append(obj.reload, obj.date);

            // ----- CONTENT AREA -----
            obj = me.myHtml.content;
            obj.wrapper = me._setObj("", "").css("width", "100%");
            me.myRoot.append(me.myHtml.menu.wrapper, me.myHtml.content.wrapper);

            // ----- LEFT COLUMN: Entry List -----
            // Displays clickable rows of edit log entries for the selected day.
            obj = me.myHtml.content.list;
            obj.wrapper = me._setObj("", "vc-list vc-grid-2col vc-grid-margin-right float-box").css("overflow-y", "hidden");

            // List header with "Entries" label.
            obj.header = me._setListHeader("");
            var line = me._setListItem();
            line.column.append(me._setListElement("", "").html(me.specific.resources.entries));
            obj.header.append(line.item);

            // Scrollable container where entry rows are dynamically inserted.
            obj.entries = me._setObj("entries", "vc-list-table").css("border", "1px solid #ddd");
            obj.wrapper.append(obj.header, obj.entries);
            me.myHtml.content.wrapper.append(obj.wrapper);


            // ----- RIGHT COLUMN: Detail Panel -----
            // Shows charts and change logs for the currently selected entry.
            obj = me.myHtml.content.details;
            obj.wrapper = me._setObj("", "vc-list vc-grid-2col float vc-grid-margin-left float-box");

            // Logic rule summary displayed above the charts.
            obj.logic = me._setObj("", "vc-grid-margin-bottom").css("height", "30px");

            // Archive data section (chart + change list).
            obj.archive = { wrapper: {}, header: {}, chart: {}, list: {} };
            me._buildHtmlCharts(obj.archive, "archive", me.specific.resources.archive, true);

            // Raw data section (chart + change list).
            obj.raw = { wrapper: {}, header: {}, chart: {}, list: {} };
            me._buildHtmlCharts(obj.raw, "raw", me.specific.resources.rawData, false);

            obj.wrapper.append(obj.logic, obj.archive.wrapper, obj.raw.wrapper);

            me.myHtml.content.wrapper.append(obj.wrapper);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    /**
     * Builds the HTML structure for one chart section (either archive or raw).
     * Each section contains:
     *   - A bold header label.
     *   - A chart container div (Highcharts will be rendered here).
     *   - A list container (for displaying individual value changes).
     *
     * @param {object} obj - Object to store created DOM element references.
     * @param {string} type - Section identifier ("archive" or "raw"), used in element IDs.
     * @param {string} caption - Localized label for the section header.
     * @param {boolean} addBottomMargin - Whether to add CSS bottom margin (archive=true, raw=false).
     * @returns {boolean} true on success.
     */
    _buildHtmlCharts: function (obj, type, caption, addBottomMargin) {
        /// <summary>
        /// This function builds the html structure only
        /// </summary>
        var me = this;
        try {
            obj.wrapper = me._setObj("", addBottomMargin ? "vc-grid-margin-bottom " : "");
            obj.header = me._setObj("", "").css("font-weight", "bold").css("height", "20px").html(caption);
            obj.chart = me._setObj("div-chart-" + type, "vc-grid-2col vc-grid-margin-right float-box").css("height", "300px").css("border", "1px solid #ddd");
            obj.list = me._setObj("", "vc-list vc-grid-2col float-box").css("border", "1px solid #ddd");
            obj.wrapper.append(obj.header, obj.chart, obj.list);
            return true;
        } catch (e) { me._writeErr(e); return false; }
        return false;
    },

    // =========================================================================
    // EVENT BINDING
    // =========================================================================

    /**
     * Binds all interactive event handlers:
     *   1. Reload button click → re-fetches data from server.
     *   2. Entry list item click → selects the entry and shows its details.
     *   3. Date picker (vcDateBox) → updates the selected day in state.
     */
    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {

            // Reload button: triggers a fresh data fetch for the current day.
            me.myHtml.menu.reload.off("click").on("click", function () { me._fetch(); });


            // Entry list: delegated click handler for dynamically created list items.
            // Using delegation ensures newly added rows after a fetch are also clickable.
            me.myHtml.content.list.entries.off("click", ".vc-list-item").on("click", ".vc-list-item", function () {
                me._selectDetails($(this));

            });

            // Date picker initialization: single-day mode with a callback that
            // updates the internal day state when the user picks a new date.
            me.myHtml.menu.date.vcDateBox({
                mode: "Single", align: "center", interval: 1, defaultDate: me.myStatus.day, langID: me.settings.userLangIDForCulture, callback: function (obj) { me.myStatus.day = obj.singleDate; }
            });



        } catch (e) { me._writeErr(e); }
    },

    // =========================================================================
    // DETAIL PANEL LOGIC
    // =========================================================================

    /**
     * Handles the selection of a list entry.
     * Visually highlights the clicked row, reveals the detail panel,
     * and triggers detail rendering (logic info, charts, logs).
     *
     * @param {jQuery} obj - The clicked .vc-list-item jQuery element.
     * @returns {boolean} true on success, false on error.
     */
    _selectDetails: function (obj) {
        /// <summary>
        /// This function 
        /// </summary>
        var me = this;
        try {

            // Remove highlight from all entries, then highlight the selected one.
            me.myHtml.content.list.entries.find(".vc-list-item").removeClass("selected");
            obj.addClass("selected");

            // Make the detail panel visible (it is hidden until first selection).
            me.myHtml.content.details.wrapper.show();

            // Render the full detail view for the selected entry.
            me._showDetails(obj);

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    /**
     * Renders the detail panel for the selected edit log entry.
     * Displays the logic rule summary and determines which chart sections to show:
     *   - If the logic rule has EditRawData=true → show BOTH archive and raw (split height).
     *   - Otherwise → show only the archive chart (full height).
     *
     * @param {jQuery} obj - The selected list item containing data attributes with entry details.
     * @returns {boolean} true on success, false on error.
     */
    _showDetails: function (obj) {
        /// <summary>
        /// This function 
        /// </summary>
        var me = this;
        try {

            // Retrieve the logic rule from the list item's stored data.
            var logic = obj.data("logicrule");

            var html = me.myHtml.content.details.logic;

            // Build the logic rule summary header showing:
            // Rule name, interval count, interval type (single values vs. days), and entry ID.
            header = me._setListHeader("");
            var line = me._setListItem();
            line.column.append(me._setListElement("", "").html(logic.Name + " - " + logic.LogicInterval + " " + (logic.LogicIntervalType == 1 ? me.specific.resources.singleValues : me.specific.resources.days) + " (ID: " + obj.data("id") + ")"));
            header.append(line.item);
            html.html(header);
            //TODO: add IDEV
            //var idev = obj.data("idevsettings");
            //console.info(idev);

            //DEV ONLY: logic.EditRawData = false;
            //logic.EditRawData = false;

            // Decide which charts to render based on the logic rule configuration.
            if (logic.EditRawData) {
                // Both archive and raw were edited → render two charts at half height each.
                me._showChart(obj, true, false);
                me._showChart(obj, false, false);
            } else {
                // Only archive was edited → render one chart at full available height.
                me._showChart(obj, true, true);
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    /**
     * Renders a chart visual (archive or raw) for the selected entry.
     * Steps:
     *   1. Calculate and set container dimensions based on display mode.
     *   2. Create a unique container element for the Highcharts visual.
     *   3. Load the appropriate server-side visual (VISUAL_RAMP_EDITLOG_ARCHIVE
     *      or VISUAL_RAMP_EDITLOG_RAW) into the container via addVisualBaseByName.
     *   4. Generate the change log list next to the chart.
     *
     * @param {jQuery} obj - The selected list item with data attributes.
     * @param {boolean} bShowArchive - true = render archive chart, false = render raw chart.
     * @param {boolean} bShowArchiveOnly - true = archive-only mode (full height), false = split mode.
     * @returns {boolean} true on success, false on error.
     */
    _showChart: function (obj, bShowArchive, bShowArchiveOnly) {
        /// <summary>
        /// This function fetches the list for the left column
        /// </summary>
        var me = this;
        try {
            // Get the edit log entry ID to pass as parameter to the chart visual.
            var id = obj.data("id");


            // Determine the available height: full if only one chart, split if two.
            let h = bShowArchiveOnly ? me.myStatus.charts.heightFull : me.myStatus.charts.heightSplit;

            // Subtract the section header height to get the actual chart area height.
            let hChart = h - me.myHtml.content.details.archive.header.outerHeight();

            // Apply dimensions to the archive section elements.
            let archive = me.myHtml.content.details.archive;

            archive.wrapper.height(h);
            archive.chart.height(hChart);
            archive.list.height(hChart);

            // Apply dimensions to the raw section and control its visibility.
            let raw = me.myHtml.content.details.raw;

            if (bShowArchiveOnly) {
                // In archive-only mode, hide the entire raw section.
                raw.wrapper.hide();
            } else {
                // In split mode, show the raw section with calculated dimensions.
                raw.wrapper.height(h);
                raw.chart.height(hChart);
                raw.list.height(hChart);
                raw.wrapper.show();
            }

            // Determine which container ID prefix and visual name to use.
            var myDiv = bShowArchive ? "div-chart-archive-" : "div-chart-raw-";
            var sVisual = bShowArchive ? "VISUAL_RAMP_EDITLOG_ARCHIVE" : "VISUAL_RAMP_EDITLOG_RAW";
            var chart = bShowArchive ? archive.chart : raw.chart;

            // Create a container with a unique random ID to host the chart visual.
            // This prevents DOM ID conflicts when charts are re-rendered.
            me.container = me.getRandomIDContainerObj(myDiv, true);
            chart.html(me.container.obj);
            me.container.obj.width(parseInt(chart.width()));
            me.container.obj.height(parseInt(chart.height()));

            // Display a loading spinner while the chart visual is initializing.
            me._setLoadingIcon(me.container.obj);
        
            // Dynamically load the Highcharts visual from the server.
            // The EditLogId parameter tells the chart which edit log entry to visualize.
            me.vcV.addVisualBaseByName(myDiv, sVisual, me.container.random, getCurrentTimestamp(), parseInt(chart.height()), parseInt(chart.width()), "", JSON.stringify({ EditLogId: id }), 1);

            // Render the value change log list beside the chart.
            // Uses editlistarchive or editlistraw data depending on which chart is shown.
            me._generateLogList(bShowArchive ? me.myHtml.content.details.archive : me.myHtml.content.details.raw, bShowArchive ? obj.data("editlistarchive") : obj.data("editlistraw"));



        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    // =========================================================================
    // DATA FETCHING
    // =========================================================================

    /**
     * Fetches edit log entries from the server for the currently selected day.
     * Sends TypeId=1 with the day string to the server-side getData method.
     * On success, populates the entry list and auto-selects the first entry.
     *
     * @returns {boolean} true on success, false on error.
     */
    _fetch: function () {
        /// <summary>
        /// This function fetches the list for the left column
        /// </summary>
        var me = this;
        try {
            // Show a loading indicator in the entry list while waiting for the response.
            me._setLoadingIcon(me.myHtml.content.list.entries);

            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1, Day: me.myStatus.day }, function (result) {
                if (result == null) {
                    // Server returned null → display error message to the user.
                    me.showMessage(me.resources.err_loadData, true); return true;
                }

                // Store the fetched data and render the list.
                me.myData.list = result;
                me._generateList();

                // Automatically select the first entry to immediately show details.
                var entries = me.myHtml.content.list.entries.find(".vc-list-item")
                if (entries.length > 0) me._selectDetails($(entries[0]));

            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    // =========================================================================
    // LIST RENDERING
    // =========================================================================

    /**
     * Generates the complete entry list from the fetched data.
     * Clears the existing list content, creates a row for each entry,
     * and applies zebra-stripe styling. Shows a placeholder message if empty.
     *
     * @returns {boolean} true if entries were rendered, false if list is empty or on error.
     */
    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {

            // If no data was returned or the array is empty, show informational message.
            if (me.myData.list === null || me.myData.list.length == 0) {
                me.myHtml.content.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            // Clear existing list content before repopulating.
            me.myHtml.content.list.entries.html("");

            // Create one list row per edit log entry.
            for (i = 0; i < me.myData.list.length; i++) { me._fillRow(me.myData.list[i]); };

            // Apply alternating background colors for better readability.
            me._setAltListStyle(me.myHtml.content.list.entries);
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    /**
     * Creates and appends a single row in the entry list for one edit log entry.
     * Displays:
     *   - The affected timespan (first timestamp to last timestamp of edits).
     *   - Which data was modified (archive only, raw only, or both).
     *   - The username who performed the edit.
     *   - The exact timestamp when the edit was recorded.
     *
     * All entry data is stored as jQuery .data() attributes on the row element,
     * so it can be retrieved later without additional server calls when clicked.
     *
     * @param {object} row - A single edit log entry object from the server response.
     * @returns {boolean} true on success, false on error.
     */
    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {

            var line = me._setListItem();

            // Attach all entry data to the DOM element for later retrieval on click.
            line.item.addClass("found").data("id", row.Id).data("bsaid", row.Bsaid).data("timestamp", row.Timestamp).data("logicrule", row.LogicRule).data("idevsettings", row.IdevSettings).data("editlistarchive", row.EditListArchive).data("editlistraw", row.EditListRaw);

            // Main line: bold timespan (e.g., "01.06.2026 08:00 - 12:00 h").
            var html = $("<div>");
            html.append("<b>" + me._getTimespan(row) + "</b> ");
            //_getTimespan

            // Sub-line: data type info, username, and edit timestamp.
            var sub = $("<div>").css("font-size", "smaller");

            // Determine which data types were edited based on LogicDataType and EditRawData flag.
            // LogicDataType == 1 means archive-based logic; EditRawData indicates raw was also touched.
            sub.append(row.LogicRule.LogicDataType == 1 ? (row.LogicRule.EditRawData ? me.specific.resources.rawData + " & " + me.specific.resources.archive : me.specific.resources.archive) : me.specific.resources.rawData);

            // Append the username who made the edit (e.g., "Lastname, Firstname" or "RAC").
            sub.append(" - (" + row.UserName + ")");

            // Append the formatted timestamp of when the edit was persisted.
            sub.append("<br/>" + moment(row.Timestamp).format("DD.MM.YYYY HH:mm:ss") + " h");
            html.append(sub);
            line.column.append(me._setListElement("", "").html(html));

            me.myHtml.content.list.entries.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    /**
     * Calculates the display timespan for an edit log entry.
     * Takes the first and last timestamp from the edit list (archive or raw)
     * to show the range of data that was affected.
     *
     * @param {object} row - An edit log entry with EditListArchive and/or EditListRaw.
     * @returns {string} Formatted timespan string, e.g., "01.06.2026 08:00 - 12:00 h".
     */
    _getTimespan: function (row) {
        /// <summary>
        /// This function 
        /// </summary>
        var me = this;
        try {

            // Use archive list if available, otherwise fall back to raw list.
            let list = row.EditListArchive != null ? row.EditListArchive : row.EditListRaw;

            // Format: full date+time for the start, only time for the end (same day assumed).
            return moment(list[0].Timestamp).format("DD.MM.YYYY HH:mm") + " - " + moment(list[list.length - 1].Timestamp).format("HH:mm") + " h";

        } catch (e) { me._writeErr(e); return "Err-"; }
    },

    // =========================================================================
    // CHANGE LOG LIST
    // =========================================================================

    /**
     * Generates the change log list for a chart section (archive or raw).
     * Displays each individual value change as a row showing:
     *   "HH:mm h: [old value] -> [new value]"
     * Values are formatted to 3 decimal places. Null values show "empty" label.
     *
     * @param {object} obj - The chart section reference (archive or raw) containing the .list element.
     * @param {Array} logs - Array of EditEntry objects with Timestamp, From, and To values.
     * @returns {boolean} true on success, false on error.
     */
    _generateLogList: function (obj, logs) {
        /// <summary>
        /// This function generates the table and fills the list with data
        /// </summary>
        var me = this;
        try {
            // If no log entries exist, show a placeholder message.
            if (logs == null) {
                obj.list.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return true;
            }

            // Create the list header with "Changes" label.
            let header = me._setListHeader("");
            let line = me._setListItem();
            line.column.append(me._setListElement("", "").html(me.specific.resources.changes));
            header.append(line.item);
            obj.list.html(header);

            // Container for all change log rows.
            var entries = me._setObj("", "vc-list-table");

            // Iterate over each edit entry and create a row.
            for (i = 0; i < logs.length; i++) {

                let line = me._setListItem();
                line.item.addClass("found");

                // Format the "from" value: show 3 decimal places or "empty" if null.
                let sFrom = "";
                if (logs[i].From != null) {
                    let from = $("<span>").html(logs[i].From);
                    from.formatDouble(3);
                    sFrom = from.html();
                } else {
                    sFrom = me.specific.resources.empty;
                }

                // Format the "to" value: show 3 decimal places or "empty" if null.
                let sTo = "";
                if (logs[i].To != null) {
                    let to = $("<span>").html(logs[i].To);
                    to.formatDouble(3);
                    sTo = to.html();
                } else {
                    sTo = me.specific.resources.empty;
                }

                // Build the row content: "HH:mm h: [from] -> [to]"
                let html = $("<div>");
                html.append(moment(logs[i].Timestamp).format("HH:mm") + " h: " + sFrom + " ->  " + sTo);
                line.column.append(me._setListElement("", "").html(html));
                entries.append(line.item);

            };

            // Apply alternating row styling and append to the list container.
            me._setAltListStyle(entries);
            obj.list.append(entries);

            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    // =========================================================================
    // LAYOUT CALCULATIONS
    // =========================================================================

    /**
     * Calculates and sets all element dimensions relative to the total visual size.
     * This ensures the widget adapts to different container sizes.
     * Computes:
     *   - List panel height (full height minus menu).
     *   - Detail panel width (total width minus list panel width).
     *   - Chart heights for full mode (one chart) and split mode (two charts).
     *
     * Also hides the detail panel initially (shown only after an entry is selected).
     *
     * @returns {boolean} true on success, false on error.
     */
    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            if (me.error) { return false; }
            let details = me.myHtml.content.details;

            // Calculate available content height: total visual height minus menu and padding.
            let hList = me._getVisualHeight() - me.myHtml.menu.wrapper.outerHeight() - 14;

            // Apply the calculated height to both content columns.
            me.myHtml.content.wrapper.css("height", hList);
            me.myHtml.content.list.wrapper.css("height", hList);
            me.myHtml.content.list.entries.css("height", hList - 30);
            details.wrapper.css("height", hList);

            // Detail panel width = total visual width minus left list width minus margins.
            details.wrapper.css("width", me._getVisualWidth() - me.myHtml.content.list.wrapper.outerWidth() - 18);

            // Subtract the logic header height from available chart space.
            hList -= details.logic.outerHeight() - 12;

            // Pre-calculate chart heights for both display modes:
            // Full = entire remaining height (when only archive is shown).
            // Split = half the remaining height (when both archive and raw are shown).
            me.myStatus.charts.heightFull = parseInt(hList) - 45;
            me.myStatus.charts.heightSplit = parseInt(hList / 2) - 22;

            // Set initial dimensions for both chart sections.
            details.archive.wrapper.css("height", me.myStatus.charts.heightSplit);
            details.archive.chart.css("width", details.archive.wrapper.outerWidth() - details.archive.list.outerWidth() - 20);
            details.raw.wrapper.css("height", me.myStatus.charts.heightSplit);
            details.raw.chart.css("width", details.raw.wrapper.outerWidth() - details.raw.list.outerWidth() - 20);

            // Hide detail panel until the user selects an entry from the list.
            me.myHtml.content.details.wrapper.hide();
        } catch (e) { me._writeErr(e); return false; }
        return true;
    },

    // =========================================================================
    // ERROR HANDLING
    // =========================================================================

    /**
     * Handles visual error states by hiding the main UI elements.
     * Called by the base class when an error message needs to be displayed.
     * Ensures the error message is visible without confusing partial UI elements.
     *
     * @param {boolean} bError - true if an error occurred, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    specificInfoHandling: function (bError) {
        /// <summary>
        /// This function handles error states - it hides specific objects on error message
        /// </summary>
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.menu.wrapper.hide();
                me.myHtml.content.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});